/* src/app/shared/ui-kit/pa-tab/pa-tab.component.scss */
.pa-tab {
  display: inline-block;
  line-height: 1.5;
}
.pa-tab .pa-tab-content-wrap {
  display: inline-flex;
  align-items: center;
}
.pa-tab .pa-tab-content {
  display: inline-flex;
  align-items: center;
}
.pa-tab .pa-tab-tooltip {
  margin-left: 4px;
  font-size: 14px;
  color: var(--secondary-subtle-inverse);
  cursor: pointer;
  pointer-events: auto;
  flex-shrink: 0;
}
.pa-tab p-tab.p-tab-active .pa-tab-tooltip {
  color: var(--p-tabs-tab-active-color);
}
.pa-tab .pa-tab-loading {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.pa-tab .pa-tab-loading ion-spinner {
  width: 14px;
  height: 14px;
  color: var(--primary-regular-default);
}
.pa-tab--link .pa-tab-content-wrap {
  position: relative;
}
.pa-tab--link .pa-tab-content {
  color: var(--p-tabs-tab-color);
  font-weight: var(--p-tabs-tab-font-weight);
  text-decoration: none;
}
.pa-tab--link .pa-tab-content-wrap::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: -8px;
  height: 2px;
  background: transparent;
}
.pa-tab--link .pa-tab-content-wrap.p-highlight .pa-tab-content,
.pa-tab--link .pa-tab-content-wrap.p-highlight .pa-tab-tooltip {
  color: var(--p-tabs-tab-active-color);
}
.pa-tab--link .pa-tab-content-wrap.p-highlight::after {
  background: var(--primary-regular-default);
}
@media (hover: hover) and (pointer: fine) {
  .pa-tab--link .pa-tab-content-wrap:hover .pa-tab-content,
  .pa-tab--link .pa-tab-content-wrap:hover .pa-tab-tooltip {
    color: var(--p-tabs-tab-active-color);
  }
  .pa-tab--link .pa-tab-content-wrap:hover::after {
    background: var(--primary-regular-default);
  }
}
/*# sourceMappingURL=pa-tab.component.css.map */
